import Button from '@mui/material/Button';
import DownloadIcon from './DownloadIcon';
import { useTranslation } from 'react-i18next';

export default function DownloadButton() {
    const { t } = useTranslation();

    return (
        <Button variant="text"
            sx={{
                backgroundColor: 'button.main',
                color: 'text.primary',
                fontSize: {
                    xs: 12,
                    md: 13,
                    xl: 14,
                },
                
            }}
            endIcon={<DownloadIcon viewBox="0 0 36 36" sx={{ mt: '5px' }} />}
        >
            {t('app_download')}
        </Button>
    )

}